// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"f6622a33","132":"59b285f0"}[chunkId] + ".chunk.js";
};